












import { Component, Vue, Prop } from 'vue-property-decorator';
import AgroResponsiveTable from "@/components/agroResponsiveTable/AgroResponsiveTable.vue";
import { InfractionDTO } from "@/api/environmental/types";

 @Component({
   name: 'CarInfractionsTable',
   components: {
     AgroResponsiveTable: AgroResponsiveTable,
   },
 })

export default class CarInfractionsTable extends Vue {
  @Prop({ type: Array, required: true })
  private infractions!: InfractionDTO[];

  private a: InfractionDTO[] = [];

  private tableColumns = [
    { name: "cropLabel" },
    { name: "formattedCropArea" },
    { name: "infractionsTypeTranslated" },
    { name: "formattedArea" },
    { name: "cropTypeTranslated" }
  ];

  private columnsLabel: object = {};

  private async created() {
    this.columnsLabel = {
      cropLabel: 'string',
      formattedCropArea: 'number',
      infractionsTypeTranslated: 'string',
      formattedArea: 'number',
      cropTypeTranslated: 'string',
    };
    
  }
}
